/**
 * Vanilla collapse module — replaces Bootstrap 3 collapse JS.
 *
 * Trigger markup:
 *   <div data-collapse-toggle="#targetId">
 * or
 *   <div data-collapse-toggle href="#targetId">
 *
 * Target markup:
 *   <div class="collapse" id="targetId">
 *
 * CSS contract (unchanged from Bootstrap 3):
 *   .collapse          { display: none; }
 *   .collapse.in       { display: block; }
 */

// Guard against double-initialisation when multiple packs import this module
if ((window as any).__collapseInitialised) {
  // already running — bail out so listeners aren't registered twice
} else {
(window as any).__collapseInitialised = true;

const TOGGLE_ATTR = "data-collapse-toggle";
const TOGGLE_SELECTOR = `[${TOGGLE_ATTR}]`;

function getTargetId(trigger: HTMLElement): string | null {
  // First check the attribute value itself, then fall back to href
  const attrValue = trigger.getAttribute(TOGGLE_ATTR)?.trim();
  if (attrValue && attrValue.length > 0) return attrValue;

  const href = trigger.getAttribute("href")?.trim();
  if (href && href.startsWith("#")) return href;

  return null;
}

function toggle(trigger: HTMLElement): void {
  const selector = getTargetId(trigger);
  if (!selector) return;

  const target = document.querySelector<HTMLElement>(selector);
  if (!target) return;

  const isOpen = target.classList.contains("in");

  target.classList.toggle("in", !isOpen);
  trigger.setAttribute("aria-expanded", String(!isOpen));
}

// --- listener (delegated on document — works for AJAX-injected content) ---

document.addEventListener("click", (e: MouseEvent) => {
  const trigger = (e.target as HTMLElement).closest<HTMLElement>(TOGGLE_SELECTOR);
  if (!trigger) return;

  e.preventDefault();
  toggle(trigger);
});

} // end of double-init guard
